export default __webpack_public_path__ + "media/images/svg/pale-in-icon-round-d3b58aadc733d3a965a095a6c5e0f92a.svg";